<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" fixed clipped app v-if="showDrawer">
      <v-img :aspect-ratio="16/6" src="">
        <v-layout pa-2 column fill-height class="primary white--text">
          <v-flex shrink class="mt-2 mb-2 header-logo">
            <img :src="this.whiteLogoUrl" v-if="!!this.whiteLogoUrl">
            <h2 v-else class="text-xs-center">{{ this.company }}</h2>
          </v-flex>

          <v-spacer></v-spacer>

          <v-flex shrink>
            <a @click="goTo('profile')" class="white--text">
              <div class="subheading">{{ $auth.currentUser.fullname }}</div>
              <div class="body-1">
                {{ $auth.currentUser.email }}
                <span style="float: right;">
                  {{ $store.state.userBalance | currency }}
                </span>
              </div>
            </a>
          </v-flex>
        </v-layout>
      </v-img>

      <v-divider></v-divider>

      <v-list class="pt-0 mt-4" dense>
        <v-list-tile v-for="item in menu" :key="item.title" @click=" item.route.name ? goTo(item.route.name) : goTo(item.route)">
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-group no-action :value="adminActive" v-if="$auth.isOper()">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('admin') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="item in operatorMenu" :key="item.title" @click="goTo(item.route)">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group no-action :value="adminActive" v-if="$auth.isAdmin() || $auth.isMainAdmin() || $auth.isDev()">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="online-list-title">{{ $t('admin') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="item in adminMenu.filter(permitted)" :key="item.title" @click="goTo(item.route)">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group no-action :value="devActive" v-if="$auth.isDev()">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title class="online-list-title">{{ $t('dev') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="item in devMenu" :key="item.title" @click="goTo(item.route)">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-group no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('configurations') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile v-for="item in customerMenu" :key="item.title" @click="goTo(item.route)">
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.title }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-divider class="my-2"></v-divider>
        
        <v-list-tile @click="goTo('partnersApiDocs')">
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon left small>code</v-icon>
              {{ $t('apiDocumentation') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="goTo('logout')">
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('logout') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>

    </v-navigation-drawer>

    <v-toolbar dense fixed clipped-left app dark color="primary" v-if="showToolbar">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title class="headline text-uppercase">
        {{ company }}
      </v-toolbar-title>
    </v-toolbar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer class="pa-3" color="transparent">
      <v-spacer></v-spacer>
      <div>
        &copy; {{ company }} {{ new Date().getFullYear() }} v{{ appVersion }}
        &nbsp;
        <a :href="termsAndConditions.value" target="_blank" v-if="hasTermsAndConditions"> {{ $t('termsAndConditions') }} </a>
      </div>
    </v-footer>

    <Notification></Notification>
    <ConfirmDialog ref="confirm"></ConfirmDialog>
  </v-app>
</template>

<script>
import Setting from '@/client/setting'
import User from '@/client/user'

export default {
  name: 'App',

  data () {
    return {
      referralSetting: {},
      overweightSetting: {},
      termsAndConditions: {},
      mini: false,
      drawer: !!this.$auth.currentUser.id,
      showFooter: this.$auth.currentUser.id,
      showInvoicing: {},

      operatorMenu: [
        { title: this.$tc('models.user', 2), route: 'users', model: 'User' },
        { title: this.$tc('models.transaction', 2), route: 'transactions', model: 'Transaction' },
      ],

      devMenu: [
        { title: this.$tc('models.provider', 2), route: 'providers' },
        { title: this.$tc('models.validator', 2), route: 'validators' },
        { title: this.$tc('models.systemSetting', 2), route: 'systemSettings' },
      ],

      customerMenu: [
        { title: this.$tc('models.address', 2), route: 'addresses' },
        { title: this.$tc('models.package', 2), route: 'packages' },
        { title: this.$tc('preferences'), route: 'preferences' },
        { title: this.$t('externalApis'), route: 'externalApis' },
        { title: this.$t('ownAgreements'), route: 'ownAgreements' }
      ],

      allowedRoutes: ['taxFiscalDataForm', 'newStore', 'login', 'logout'],
      demoShipmentRoutes: ['newShipment', 'newParcel', 'newRate', 'shipmentConfirm'],
      verifyFiscalDataSetting: {}
    }
  },

  computed: {
    hasTermsAndConditions () {
      return !!(this.termsAndConditions || {}).value
    },

    showReferralCode () {
      return this.referralSetting.value === '1'
    },

    menu () {
      let menu = [
        { title: 'Dashboard', route: 'dashboard' },
        { title: this.$tc('models.shipment', 2), route: 'shipments' },
        { title: this.$t('quoteNow'), route: 'newQuote' },
        // { title: this.$tc('models.address', 2), route: 'addresses' },
        // { title: this.$tc('models.package', 2), route: 'packages' },
        { title: this.$t('myTransactions'), route: 'myTransactions' },
        { title: this.$t('ecommerceShops'), route: 'stores' },
        { title: this.$t('addFunds'), route: 'addFunds' },
        { title: this.$tc('models.fiscalDatum', 2), route: 'fiscalData' },
      ]

      if (!this.$auth.isCust()) {
        menu.pop()
      }

      if (this.showReferralCode) {
        menu.push({ title: this.$tc('referrals', 2), route: 'referrals' })
      }

      if (this.$auth.isDev() || this.overweightSetting.value === '1') {
        menu.push({ title: this.$tc('models.overweight', 2), route: 'overweights' })
      }

      if (this.showInvoicing) {
        menu.push({ title: this.$tc('models.invoice', 2), route: 'invoices', model: 'Invoice' })
      }

      return menu
    },

    adminMenu () {
      let menuArr = [
        { title: this.$tc('models.user', 2), route: 'users', model: 'User' },
        { title: this.$tc('models.transaction', 2), route: 'transactions', model: 'Transaction' },
        { title: this.$tc('models.report', 2), route: 'reports', model: 'Report' },
        { title: this.$tc('models.notice', 2), route: 'notices', model: 'Notice' },
        { title: this.$tc('models.carrier', 2), route: 'carriers', model: 'Carrier' },
        { title: this.$tc('models.waybill', 2), route: 'waybills', model: 'Waybill' },
        { title: this.$tc('models.bankAccount', 2), route: 'bankAccounts', model: 'BankAccount' },
        { title: this.$tc('models.setting', 2), route: 'settings', model: 'Setting' },
        { title: 'Analytics', route: 'analytics', model: 'Dashboard' },
        { title: this.$tc('models.country', 2), route: 'countries', model: 'Country' },
        { title: this.$t('manualShipments'), route: 'manualShipments', model: 'Shipment' },
        { title: this.$tc('models.zone', 2), route: 'zones', model: 'Zone' },
        { title: this.$tc('models.pickup', 2), route: 'pickups', model: 'Pickup' },
      ]

      if (this.showInvoicing) {
        menuArr.push({ title: this.$tc('models.csd', 2), route: 'csds', model: 'Csd' })
      }

      return menuArr
    },

    breakpoint () {
      return this.$vuetify.breakpoint.name
    },

    adminActive () {
      const routes = this.adminMenu.map(o => o.route).concat([
        'userFiscalData',
        'userPrices',
        'userTransactions',
        'carrierSettings',
        'services'
      ])
      return routes.indexOf(this.$route.name) !== -1
    },

    devActive () {
      const routes = this.devMenu.map(o => o.route)
      return routes.indexOf(this.$route.name) !== -1
    },

    showToolbar () {
      return !!this.$auth.currentUser.id &&
        (this.breakpoint !== 'lg' && this.breakpoint !== 'xl')
    },

    showDrawer () {
      return !!this.$auth.currentUser.id
    }
  },

  methods: {
    permitted (item) {
      return this.$auth.can(item.model, 'read')
    },

    async verifyFiscalDetails () {
      //Hide user ability if fiscal data is unverified

      if (!this.$store.state.verifyUserFIscalData) {
        this.verifyFiscalDataSetting = await Setting.byKey('verify_user_fiscal_data')

        if (this.verifyFiscalDataSetting) this.$store.state.verifyUserFIscalData = this.verifyFiscalDataSetting.value
      }

      if (this.$store.state.verifyUserFIscalData == '0' || !this.$store.state.verifyUserFIscalData) { return }

      if (!this.$auth.currentUser) {return}

      if (!this.$auth.isCust() || this.$auth.currentUser.fiscal_data_verified) { return }

      if (this.demoShipmentRoutes.indexOf(this.$route.name) > -1) {
        var user = await User.findOne(this.$auth.currentUser.id)

        if ( (user.total_shipments == 0 && this.$route.name == 'newShipment') || (user.total_shipments <= 1 && this.$route.name != 'newShipment') ) { return }
      }

      if (!this.$auth.currentUser.fiscal_data_verified && this.allowedRoutes.indexOf(this.$route.name) <= -1) {
        this.goTo('verifyFiscalDataIndex')
      }
    },

    async fetchInvoicingSetting () {
      try {
        const res = await Setting.byKey('invoicing')
        this.showInvoicing = res.value === '1'
      } catch {
        this.showInvoicing = false
      }
    }
  },

  watch: {
    '$auth.currentUser': {
      handler () {
        this.drawer = !!this.$auth.currentUser.id
        this.showFooter = !!this.$auth.currentUser.id
        this.$store.state.userBalance = this.$auth.currentUser.balance
      },
      deep: true
    }
  },

  async mounted () {
    window.document.title = this.company
    this.referralSetting = await Setting.byKey('referral_code')
    this.overweightSetting = await Setting.byKey('overweights')
    this.termsAndConditions = await Setting.byKey('terms_conditions')
    this.$root.$confirm = this.$refs.confirm

    var ownAgreements = await Setting.byKey('user_own_agreements') || {}
    if (ownAgreements && ownAgreements.value == '0') this.customerMenu.pop()
    this.fetchInvoicingSetting()
  },

  async updated () {
    this.verifyFiscalDetails()
  },
}
</script>

<style scoped>
  .online-list-title {
    position: absolute;
  }

  .unread-msg-dot-title {
    position: relative;
    top: 0px;
    left:  40px;
  }
</style>
